<template>
  <div class="container-fluid mt-5">
    <card>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3 class="mb-0">{{ $t("COMMON.ADD") }}</h3>
        <base-button type="secondary" @click="goBack">
          {{ $t("COMMON.RETURN_TO_LIST") }}
        </base-button>
      </div>
      <establishment-transfer-form
        :transferModel="transfer"
        :loading="loading"
        :submitLabel="$t('COMMON.SAVE')"
        @submit="submit"
      />
    </card>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import defaultTransfer from "./defaultEstablishmentTransfer";
import EstablishmentTransferForm from "./partials/EstablishmentTransferForm.vue";

export default {
  name: "AddEstablishmentTransferPage",
  components: { EstablishmentTransferForm },
  data() {
    return {
      transfer: cloneDeep(defaultTransfer),
      loading: false,
    };
  },
  created() {
    this.prefillFromQuery();
  },
  methods: {
    prefillFromQuery() {
      const { source_establishment_id } = this.$route.query;
      if (source_establishment_id) {
        this.transfer.source_establishment_id = source_establishment_id;
      }
    },
    async submit(payload) {
      this.loading = true;
      try {
        await this.$store.dispatch("establishmentTransfers/add", {
          data: payload,
        });
        const transfer = this.$store.getters["establishmentTransfers/transfer"];
        this.goToView(transfer.id);
      } finally {
        this.loading = false;
      }
    },
    goToView(id) {
      this.$router.push({ name: "View EstablishmentTransfer", params: { id } });
    },
    goBack() {
      this.$router.push({ name: "List EstablishmentTransfers" });
    },
  },
};
</script>
